exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Avatar-module__icon___1vgBn,.Avatar-module__image___3nZWW{border-radius:100%!important;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;background-color:#fff}.Avatar-module__image___3nZWW{width:100%;height:100%}.Avatar-module__with-border___1N9Y9{padding:.25rem;background:#fff;border-radius:100%}.Avatar-module__huge___1Zt-K{box-shadow:0 0 17.5px rgba(0,0,0,.08)}.Avatar-module__icon___1vgBn{background-color:#0827e9;color:#fff;display:grid;justify-content:center;align-items:center}.Avatar-module__icon___1vgBn p{transform:translateY(1px);text-transform:uppercase;font-weight:700;letter-spacing:-1px;opacity:1!important}.Avatar-module__icon___1vgBn p.Avatar-module__medium___3SvnU{font-size:18px}.Avatar-module__icon___1vgBn p.Avatar-module__big___3i4SC{font-size:35px}", ""]);

// exports
exports.locals = {
	"icon": "Avatar-module__icon___1vgBn",
	"image": "Avatar-module__image___3nZWW",
	"with-border": "Avatar-module__with-border___1N9Y9",
	"huge": "Avatar-module__huge___1Zt-K",
	"medium": "Avatar-module__medium___3SvnU",
	"big": "Avatar-module__big___3i4SC"
};